import React from 'react';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';
import GatedInputEventEditor from 'app/shared/components/testing-suite/GatedInputEventEditor';

export default function InputEventTab() {
  const {
    state: { inputEvent, onInputEventChange, setIsValidJson, validationError },
  } = useTestPipelineDrawerContext();

  return (
    <GatedInputEventEditor
      defaultValue={inputEvent}
      setValue={onInputEventChange}
      setHasValidInput={setIsValidJson}
      errorMsg={validationError}
      trackingEventName="test_pipeline_input_event_edited"
    />
  );
}
